import { createI18n } from 'vue-i18n';
import { loadLocaleMessages } from './loadLocalMessages';

const i18n = createI18n({
  legacy: false,
  locale: import.meta.env.VITE_DEFAULT_LOCALE,
  fallbackLocale: import.meta.env.VITE_FALLBACK_LOCALE,
  globalInjection: true,
  messages: {}
});

async function switchLanguage(locale: string) {
  await loadLocaleMessages(locale)
  .then(messages => {
    console.log(messages);
    i18n.global.setLocaleMessage(locale, messages);
    i18n.global.locale.value = locale;
  });


}

export { switchLanguage };
export default i18n;
